import { Avatar, AvatarGroup, Box, Stack, Tooltip, Typography } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes, User } from 'types'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

interface TeamDetailsProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  densityStyles: DensityStyleTypes
}

const TeamDetailsCell: FC<TeamDetailsProps> = ({ params, densityStyles }) => {
  const values = params?.row?.team_details ?? []
  // const values = Array.isArray(params?.row?.team_details) ? params?.row?.team_details : []
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        flexWrap: 'wrap',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      <Tooltip
        title={values.map((user: User, index: number) => (
          <Stack
            key={`${user.user_uuid || user.id} - ${index}`}
            sx={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Typography sx={{ width: '100%', textAlign: 'left', color: renderColorByString(user?.role) }}>
                {user?.role}:
              </Typography>
              <Typography sx={{ width: '100%', textAlign: 'right' }}>{user?.name}</Typography>
            </Box>
          </Stack>
        ))}
      >
        <AvatarGroup
          max={densityStyles.avatarMax}
          spacing={densityStyles.avatarSpacing}
          slotProps={{
            additionalAvatar: {
              sx: {
                width: densityStyles.avatarSize,
                height: densityStyles.avatarSize,
                fontSize: densityStyles.fontSize + 2,
              },
            },
          }}
        >
          {values.length > 0 ? (
            values.map((user, index) => (
              <Avatar
                key={`${user.user_uuid || user.id} - ${index}`}
                src={user.image_512}
                sx={{ width: densityStyles.avatarSize, height: densityStyles.avatarSize }}
              />
            ))
          ) : (
            <>
              <Avatar
                sx={{
                  width: densityStyles.avatarSize,
                  height: densityStyles.avatarSize,
                  opacity: 0.1,
                  bgcolor: 'background.overlay',
                }}
              />
              <Avatar
                sx={{
                  width: densityStyles.avatarSize,
                  height: densityStyles.avatarSize,
                  opacity: 0.1,
                  bgcolor: 'background.overlay',
                }}
              />
              <Avatar
                sx={{
                  width: densityStyles.avatarSize,
                  height: densityStyles.avatarSize,
                  opacity: 0.1,
                  bgcolor: 'background.overlay',
                }}
              />
            </>
          )}
        </AvatarGroup>
      </Tooltip>
    </Box>
  )
}
export default TeamDetailsCell
